// Coffeescript transformed to Javascript via https://awsm-tools.com/code/coffee2js
// See: http://getcontenttools.com/tutorials/adding-new-tools

import ContentTools from 'ContentTools/build/content-tools.min.js';
import { coffeeExtends } from './helpers';

export const initRecipientsTool = function () {
    (function (_super) {
        coffeeExtends(RecipientsTool, _super);
        function RecipientsTool() {
            return RecipientsTool.__super__.constructor.apply(this, arguments);
        }
        ContentTools.ToolShelf.stow(RecipientsTool, 'recipients');
        RecipientsTool.label = 'Insert Recipients';
        RecipientsTool.icon = 'recipients';
        RecipientsTool.tagName = 'rcp';
        RecipientsTool.apply = (element, selection, callback) => {
            const cursor = selection.get()[0] + 1;

            const tip = element.content.substring(0, selection.get()[0]);
            const tail = element.content.substring(selection.get()[1]);
            const recipientsHtml = `<${RecipientsTool.tagName} contenteditable="false">RECIPIENTS</${
                RecipientsTool.tagName
            }>`;
            // http://getcontenttools.com/api/html-string
            element.content = tip.concat(
                new window.HTMLString.String(' ', true),
                recipientsHtml,
                new window.HTMLString.String(' ', true),
                tail,
                false
            );
            element.updateInnerHTML();
            element.taint();

            // Restore the selection
            selection.set(cursor + 12, cursor + 12);
            element.selection(selection);
            ContentTools.Tools.LineBreak.dispatchEditorEvent('tool-applied', {
                name: 'CKP_RecipientsTool',
                transform: true
            });
            callback(true);
        };
        return RecipientsTool;
    })(ContentTools.Tools.LineBreak);
};
